export default "__VITE_ASSET__DoRO$zRa__"